import {CanActivateFn, UrlTree} from '@angular/router';
import {inject} from '@angular/core';

import {LocalizedRouter} from "@app/presentation/services/localized-router";
import {LocalizeRouterService} from "@gilsdav/ngx-translate-router";
import {DeepLinkMapper} from "@app/core/shared/infrastructure/mappers/deep-link.mapper";
import {
  GetDeepLinkNavigationActionUseCase
} from "@app/core/shared/application/get-deep-link-navigation-action.use-case";
import {NavigationActionToRouteMapper} from "@app/presentation/utils/navigation-action-to-route.mapper";

export const handlePathWithoutLangPrefixGuard: CanActivateFn = async (route, state) => {
  const localizedRouter = inject(LocalizedRouter);
  const localizeRouterService = inject(LocalizeRouterService);
  const getDeepLinkNavigationActionUseCase = inject(GetDeepLinkNavigationActionUseCase);
  const navigationActionToRouteMapper = inject(NavigationActionToRouteMapper);

  const mapper = new DeepLinkMapper();
  const fallbackUrlTree = localizedRouter.parseUrl('/');

  const currentPathWithQueryParams = state.url;
  const firstSlug = currentPathWithQueryParams.split('/')[1];
  const languagesCodes = localizeRouterService.parser.locales;
  const isPrefixLanguageCode = languagesCodes.includes(firstSlug);

  if (isPrefixLanguageCode) {
    return fallbackUrlTree;
  }

  const urlTree = await pathWithQueryParamsToUrlTree(currentPathWithQueryParams);
  if (urlTree === null) {
    return fallbackUrlTree;
  }
  return localizedRouter.parseUrl(urlTree.toString());

  async function pathWithQueryParamsToUrlTree(pathWithQueryParams: string): Promise<UrlTree | null> {
    const deepLink = mapper.mapPathWithQueryParamsToDeepLink(pathWithQueryParams);
    if (deepLink === null) {
      return null;
    }
    const navigationAction = await getDeepLinkNavigationActionUseCase.execute(deepLink);
    if (navigationAction === null) {
      return null;
    }
    return navigationActionToRouteMapper.map(navigationAction);
  }
};
